export enum SignInMethod {
  SpeedboxPhone = 'SpeedboxPhone',
  SpeedboxEmail = 'SpeedboxEmail',
}
